import axios from 'axios'

document.addEventListener('DOMContentLoaded', () => {
  const modalButton = document.getElementById('donationsModalButton')

  if (modalButton) {
    const donationTarget = 100000
    let donationAmount = null

    const client = axios.create({
      baseURL: 'https://boutique.oip.org',
      timeout: 3000
    })

    client.get('/offres/dev_clients/oip/RecupDons.php')
      .then(response => {
        donationAmount = parseInt(response.data[0].montant_dons)
        const percent = Math.floor(donationAmount / donationTarget * 100)
        const progress = document.getElementById('donationProgress')

        if (progress) {
          // we update the progress bar progression, and the corresponding displayed values
          progress.setAttribute('aria-valuenow', percent)
          progress.style.width = `${percent}%`
          document.getElementById('donation-amount').innerHTML = `${donationAmount.toLocaleString('fr-FR')} €`
        }

        // we fake a click to the modal button to trigger the modal
        modalButton.click()
      })
      .catch(error => {
        // we failed to get the donation amount, we simply remove the progress bar container
        document.getElementById('donation-modal-progress-container').classList.add('hidden')
        console.log(error)
      })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/includes/donations.js